// @flow
import React, { type Node, useMemo, useCallback } from 'react';
import moment from 'moment-timezone';
import { times, unnest } from 'ramda';
import cn from 'classnames/bind';

import PlainList from '../plain-list';
import YearItem from './year-item';
import MonthItem, { type MonthItemProps } from './month-item';

import styles from './plain-list-months.module.scss';;


const cx = cn.bind(styles);
const idFormat = 'YYYY-MM';

export type ListMonthsProps = {
  amount?: number,
  activeDate?: string,
  activeDateFormat?: string,
  onMonthClick?: (date: string, format: string) => void,
  monthsInFuture?: number,
}

const PalinListMonths = ({
  amount = 12,
  activeDate = '',
  activeDateFormat,
  onMonthClick,
  monthsInFuture = 0,
}: ListMonthsProps): Node => {
  const monthsList = useMemo(() => {
    const mDate = moment().add(1 + monthsInFuture, 'months');
    const mActiveDate = moment(activeDate, activeDateFormat);
    const hasActive = mActiveDate.isValid();

    return unnest<{
      id: string,
      month: number,
      year: number,
      className: string,
      disabled: boolean
    }>(times((i) => {
      mDate.subtract(1, 'months');
      const m = mDate.month();
      const current = moment().isSame(mDate, 'month');

      const active = hasActive && mActiveDate.isSame(mDate, 'month');
      const displayYearTitle = i === 0 || m === 11;

      const monthItem = ({
        id: mDate.format(idFormat),
        month: mDate.format('MMMM'),
        year: mDate.format('YYYY'),
        className: cx(styles.month, { current, active }),
        disabled: false,
      });

      return displayYearTitle ? [{
        ...monthItem,
        disabled: true,
        className: styles.year,
      }, monthItem] : monthItem;
    }, amount));
  }, [amount, activeDate, activeDateFormat, monthsInFuture]);

  const handleMonthClick = useCallback((monthProps: MonthItemProps) => {
    const { id } = monthProps;
    if (onMonthClick) {
      onMonthClick(id, idFormat);
    }
  }, [onMonthClick]);

  return (
    <PlainList id="year_list" onClick={handleMonthClick}>
      {monthsList.map(({ id, month, year, className, disabled }) => (disabled

        ? <YearItem
          className={className}
          title={`${year}`}
          key={year}
          disabled
        />

        : <MonthItem
          key={id}
          id={id}
          month={month}
          year={year}
          className={className}
        />
      ))}
    </PlainList>
  );
};

export default PalinListMonths;
